import { refreshTokenViaAngular } from 'app/react-bridge/auth-bridge';
import { TenantStorage } from '../../session/session-decode';

// Adaptador fino sobre a ponte Angular (app/react-bridge/auth-bridge). O logout
// deixou de passar por aqui: quem encerra a sessão agora é o React (effects/logout
// + http/session-cleanup). Só o refresh de token continua delegado ao Angular,
// que segue dono do AbLogin.

/** Delega o refresh de token ao Angular, disparado na troca de conta e ao sair da conta. */
export function delegateRefreshToken(tenant: TenantStorage | null): void {
  refreshTokenViaAngular(tenant);
}
